export const GET_WAREHOUSE_REQUEST = "GET_WAREHOUSE_REQUEST";
export const GET_WAREHOUSE_SUCCESS = "GET_WAREHOUSE_SUCCESS";
export const GET_WAREHOUSE_FAILURE = "GET_WAREHOUSE_FAILURE";

export const GET_YARDOCCUPANCY_REQUEST = "GET_YARDOCCUPANCY_REQUEST";
export const GET_YARDOCCUPANCY_SUCCESS = "GET_YARDOCCUPANCY_SUCCESS";
export const GET_YARDOCCUPANCY_FAILURE = "GET_YARDOCCUPANCY_FAILURE";

export const GET_INVENTORY_REQUEST = "GET_INVENTORY_REQUEST";
export const GET_INVENTORY_SUCCESS = "GET_INVENTORY_SUCCESS";
export const GET_INVENTORY_FAILURE = "GET_INVENTORY_FAILURE";

export const GET_PICKUP_REQUEST = "GET_PICKUP_REQUEST";
export const GET_PICKUP_SUCCESS = "GET_PICKUP_SUCCESS";
export const GET_PICKUP_FAILURE = "GET_PICKUP_FAILURE";

export const GET_FINISHEDGOODSHP_REQUEST = "GET_FINISHEDGOODSHP_REQUEST";
export const GET_FINISHEDGOODSHP_SUCCESS = "GET_FINISHEDGOODSHP_SUCCESS";
export const GET_FINISHEDGOODSHP_FAILURE = "GET_FINISHEDGOODSHP_FAILURE";

export const GET_PDI_REQUEST = "GET_PDI_REQUEST";
export const GET_PDI_SUCCESS = "GET_PDI_SUCCESS";
export const GET_PDI_FAILURE = "GET_PDI_FAILURE";

export const GET_REJECTION_REQUEST = "GET_REJECTION_REQUEST";
export const GET_REJECTION_SUCCESS = "GET_REJECTION_SUCCESS";
export const GET_REJECTION_FAILURE = "GET_REJECTION_FAILURE";

export const GET_NAVBAR_BOXES_REQUEST = "GET_NAVBAR_BOXES_REQUEST";
export const GET_NAVBAR_BOXES_SUCCESS = "GET_NAVBAR_BOXES_SUCCESS";
export const GET_NAVBAR_BOXES_FAILURE = "GET_NAVBAR_BOXES_FAILURE";

export const GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_REQUEST =
  "GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_REQUEST";
export const GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_SUCCESS =
  "GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_SUCCESS";
export const GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_FAILURE =
  "GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_FAILURE";

export const GET_GRN_REPORT_HOME_REQUEST = "GET_GRN_REPORT_HOME_REQUEST";
export const GET_GRN_REPORT_HOME_SUCCESS = "GET_GRN_REPORT_HOME_SUCCESS";
export const GET_GRN_REPORT_HOME_FAILURE = "GET_GRN_REPORT_HOME_FAILURE";

export const GET_FG_REPORT_HOME_REQUEST = "GET_FG_REPORT_HOME_REQUEST";
export const GET_FG_REPORT_HOME_SUCCESS = "GET_FG_REPORT_HOME_SUCCESS";
export const GET_FG_REPORT_HOME_FAILURE = "GET_FG_REPORT_HOME_FAILURE";

export const GET_ITEM_STATUS_REPORT_HOME_REQUEST =
  "GET_ITEM_STATUS_REPORT_HOME_REQUEST";
export const GET_ITEM_STATUS_REPORT_HOME_SUCCESS =
  "GET_ITEM_STATUS_REPORT_HOME_SUCCESS";
export const GET_ITEM_STATUS_REPORT_HOME_FAILURE =
  "GET_ITEM_STATUS_REPORT_HOME_FAILURE";

export const GET_INVENTORY_AGEING_REPORT_HOME_REQUEST =
  "GET_INVENTORY_AGEING_REPORT_HOME_REQUEST";
export const GET_INVENTORY_AGEING_REPORT_HOME_SUCCESS =
  "GET_INVENTORY_AGEING_REPORT_HOME_SUCCESS";
export const GET_INVENTORY_AGEING_REPORT_HOME_FAILURE =
  "GET_INVENTORY_AGEING_REPORT_HOME_FAILURE";

export const GET_PICKLIST_AGEING_REPORT_HOME_REQUEST =
  "GET_PICKLIST_AGEING_REPORT_HOME_REQUEST";
export const GET_PICKLIST_AGEING_REPORT_HOME_SUCCESS =
  "GET_PICKLIST_AGEING_REPORT_HOME_SUCCESS";
export const GET_PICKLIST_AGEING_REPORT_HOME_FAILURE =
  "GET_PICKLIST_AGEING_REPORT_HOME_FAILURE";

export const GET_TOP10_REPORT_HOME_REQUEST = "GET_TOP10_REPORT_HOME_REQUEST";
export const GET_TOP10_REPORT_HOME_SUCCESS = "GET_TOP10_REPORT_HOME_SUCCESS";
export const GET_TOP10_REPORT_HOME_FAILURE = "GET_TOP10_REPORT_HOME_FAILURE";

export const GET_VENDOR_APPLICATION_REQUEST = "GET_VENDOR_APPLICATION_REQUEST";
export const GET_VENDOR_APPLICATION_SUCCESS = "GET_VENDOR_APPLICATION_SUCCESS";
export const GET_VENDOR_APPLICATION_FAILURE = "GET_VENDOR_APPLICATION_FAILURE";

export const GET_VENDOR_MONTHLY_REQUEST = "GET_VENDOR_MONTHLY_REQUEST";
export const GET_VENDOR_MONTHLY_SUCCESS = "GET_VENDOR_MONTHLY_SUCCESS";
export const GET_VENDOR_MONTHLY_FAILURE = "GET_VENDOR_MONTHLY_FAILURE";

export const GET_VENDOR_SUBSCRIPTION_COUNT_REQUEST = "GET_VENDOR_SUBSCRIPTION_COUNT_REQUEST";
export const GET_VENDOR_SUBSCRIPTION_COUNT_SUCCESS = "GET_VENDOR_SUBSCRIPTION_COUNT_SUCCESS";
export const GET_VENDOR_SUBSCRIPTION_COUNT_FAILURE = "GET_VENDOR_SUBSCRIPTION_COUNT_FAILURE";

export const GET_EFFICIENCY_REPORT_HOME_REQUEST =
  "GET_EFFICIENCY_REPORT_HOME_REQUEST";
export const GET_EFFICIENCY_REPORT_HOME_SUCCESS =
  "GET_EFFICIENCY_REPORT_HOME_SUCCESS";
export const GET_EFFICIENCY_REPORT_HOME_FAILURE =
  "GET_EFFICIENCY_REPORT_HOME_FAILURE";

export const GET_VENDOR_COUNT_REQUEST = "GET_VENDOR_COUNT_REQUEST";
export const GET_VENDOR_COUNT_SUCCESS = "GET_VENDOR_COUNT_SUCCESS";
export const GET_VENDOR_COUNT_FAILURE = "GET_VENDOR_COUNT_FAILURE";

export const GET_WAREHOUSE_CARD_DATA_REQUEST =
  "GET_WAREHOUSE_CARD_DATA_REQUEST";
export const GET_WAREHOUSE_CARD_DATA_SUCCESS =
  "GET_WAREHOUSE_CARD_DATA_SUCCESS";
export const GET_WAREHOUSE_CARD_DATA_FAILURE =
  "GET_WAREHOUSE_CARD_DATA_FAILURE";

export const GET_WAREHOUSE_ZONES_REQUEST = "GET_WAREHOUSE_ZONES_REQUEST";
export const GET_WAREHOUSE_ZONES_SUCCESS = "GET_WAREHOUSE_ZONES_SUCCESS";
export const GET_WAREHOUSE_ZONES_FAILURE = "GET_WAREHOUSE_ZONES_FAILURE";

export const GET_EXPANDED_GRN_REPORT_HOME_REQUEST =
  "GET_EXPANDED_GRN_REPORT_HOME_REQUEST";
export const GET_EXPANDED_GRN_REPORT_HOME_SUCCESS =
  "GET_EXPANDED_GRN_REPORT_HOME_SUCCESS";
export const GET_EXPANDED_GRN_REPORT_HOME_FAILURE =
  "GET_EXPANDED_GRN_REPORT_HOME_FAILURE";

export const GET_EXPANDED_FG_REPORT_HOME_REQUEST =
  "GET_EXPANDED_FG_REPORT_HOME_REQUEST";
export const GET_EXPANDED_FG_REPORT_HOME_SUCCESS =
  "GET_EXPANDED_FG_REPORT_HOME_SUCCESS";
export const GET_EXPANDED_FG_REPORT_HOME_FAILURE =
  "GET_EXPANDED_FG_REPORT_HOME_FAILURE";

export const GET_EXPANDED_INVENTORY_REPORT_HOME_REQUEST =
  "GET_EXPANDED_INVENTORY_REPORT_HOME_REQUEST";
export const GET_EXPANDED_INVENTORY_REPORT_HOME_SUCCESS =
  "GET_EXPANDED_INVENTORY_REPORT_HOME_SUCCESS";
export const GET_EXPANDED_INVENTORY_REPORT_HOME_FAILURE =
  "GET_EXPANDED_INVENTORY_REPORT_HOME_FAILURE";

export const GET_EXPANDED_PICKLIST_REPORT_HOME_REQUEST =
  "GET_EXPANDED_PICKLIST_REPORT_HOME_REQUEST";
export const GET_EXPANDED_PICKLIST_REPORT_HOME_SUCCESS =
  "GET_EXPANDED_PICKLIST_REPORT_HOME_SUCCESS";
export const GET_EXPANDED_PICKLIST_REPORT_HOME_FAILURE =
  "GET_EXPANDED_PICKLIST_REPORT_HOME_FAILURE";
